(() => {
  const observed = new WeakSet();
  const videos = new Set();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const visible = video => {
    const rect = video.getBoundingClientRect();
    const width = Math.max(0, Math.min(rect.right, innerWidth) - Math.max(rect.left, 0));
    const height = Math.max(0, Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0));
    return !document.hidden && rect.width > 0 && rect.height > 0 &&
      width * height / (rect.width * rect.height) >= 0.15;
  };
  const update = video => {
    if (!visible(video)) { video.pause(); return; }
    if (!video.dataset.rnrLoaded) {
      video.querySelectorAll('source[data-src]').forEach(source => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.dataset.rnrLoaded = 'true';
      video.load();
    }
    if (motion.matches) {
      video.controls = true;
      video.pause();
    } else {
      video.play().catch(() => { video.controls = true; });
    }
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => requestAnimationFrame(() => update(entry.target)));
  }, { threshold: [0, 0.15] }) : null;
  const init = root => {
    // Allow the section's DOMContentLoaded carousel setup to establish its layout.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      root.querySelectorAll('video[data-rnr-video]').forEach(video => {
        if (observed.has(video)) return;
        observed.add(video);
        videos.add(video);
        if (motion.matches) video.controls = true;
        if (observer) observer.observe(video);
        else update(video);
      });
    }));
  };
  const refresh = () => videos.forEach(video => {
    if (video.isConnected) update(video);
    else { observer?.unobserve(video); videos.delete(video); }
  });
  if (!observer) {
    addEventListener('scroll', refresh, { passive: true });
    addEventListener('resize', refresh);
  }
  document.addEventListener('visibilitychange', refresh);
  motion.addEventListener('change', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
